import gettext from 'utils/gettext';
import Backbone from 'backbone';
import $ from 'jquery';

$.ajaxSetup({
  dataFilter: function (data, type) {
    return type === 'json' && !data ? '{}' : data;
  }
});

// Load translations first, then config, then controller (because config and controller may import file with gettext).
async function load() {
  await gettext.i18nInitD.finally(() => {});

  const { default: config } = await import('utils/client-config-ex');
  const configLoaded = await config.loadD;

  if (configLoaded) {
    const { Controller } = await import('controllers/controller');
    Backbone.controller = new Controller();
    Backbone.history.start();
  }
}

load();
